import "./src/main.scss";
import "./static/fonts.css";
